
import { GET, URLS, POST, PUT, CLEAR_VALUE, REMOVE_VALUE } from '../../utils'
import { types as ToastTypes } from './toast'

export const types = {
  FETCH_ADDRESS_LIST: "ADDRESS/FETCH_ADDRESS_LIST",
  FETCH_UPDATE_ADDRESS: "ADDRESS/FETCH_UPDATE_ADDRESS"
}

const state = {
  currentAddress:null,
}

const mutations = {
  set_address(state, dic){
    state.currentAddress = dic
  }
}

const actions = {
  /**
   * 地址列表
   */
  [types.FETCH_ADDRESS_LIST] ({commit, state}, param){
    let url = URLS.list_address
    return new Promise((resolve, reject) => {
      GET(url)
        .then(response => {
          if (response.results.length) {
            commit("set_address", response.results[0])
            resolve(response.results[0]);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  /**
   * 修改/新建地址
   * @param { Object } param {"linkman":"chenwei1","telephone":"1589888","shipping_address":"123456"}
   */
  [types.FETCH_UPDATE_ADDRESS]({commit}, param){
    // 发起请求
    let url = URLS.update_address;
    return new Promise((resolve, reject) => {
      PUT(url, param)
        .then(response => {
          commit("set_address", response)
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}